import Button from './button';

export default class Accent extends Button {
  get buttonVariant() {
    return 'accent';
  }
}
